import refreshRecordBuilder from "quickfire/integration/builders/record/refresh-record-builder";
import Gameplay from "slotworks/model/gameplay/gameplay";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import FreespinWinResult from "slotworks/model/gameplay/records/results/freespin-win-result";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import AuthRequestPayload from "slotworks/model/gameplay/requests/auth-request-payload";
import SpinRequestPayload from "slotworks/model/gameplay/requests/spin-request-payload";
import { RecordBuilder } from "slotworks/server/builders/record-builder";
import { lastInArray } from "slotworks/utils/collection-utils";
import sgSpinRecordBuilder from "./sg-spin-record-builder";

class SGRecoverySpinRecordBuilder implements RecordBuilder {
    public filter(request: any, packet: QuickfireResponsePacket): boolean {
        return request instanceof AuthRequestPayload &&
            (parseInt(packet.Response.Slot.attributes.freeSpins) > 0 || parseInt(packet.Response.Slot.attributes.freeSpinTotalAwarded) > 0);
    }

    public build(
        gameplay: Gameplay,
        request: AuthRequestPayload,
        packet: QuickfireResponsePacket
    ): SpinRecord[] {

        refreshRecordBuilder.build(gameplay, request, packet);

        gameplay.isRecovered = true;
        gameplay.startBalance = gameplay.balance;

        let records: SpinRecord[] = sgSpinRecordBuilder.build(gameplay, request as SpinRequestPayload, packet);
        if (records[0] instanceof FreespinRecord) {
            const originalRecord = records[0] as FreespinRecord;

            const freespinsAwarded: number = parseInt(packet.Response.Slot.attributes.freeSpinTotalAwarded);
            const freespinsPlayed: number = Math.abs(
                parseInt(packet.Response.Slot.attributes.freeSpins) -
                freespinsAwarded
            );

            // Create a bunch of dummy freespins to represent the total played so far
            const dummyFreespins: FreespinRecord[] = this.createDummyFreespinRecords(originalRecord, freespinsPlayed);

            // The last dummy freespin is actually the recovered freespin
            const lastRecord = lastInArray(dummyFreespins) as FreespinRecord;
            lastRecord.results = originalRecord.results;
            if (freespinsPlayed === freespinsAwarded) {
                lastRecord.lastChild = true;
            }

            // Create a dummy triggering spin which accounts for all freespins won (excluding spins won by the current spin)
            const triggerRecord: SpinRecord = this.createTriggerRecord(originalRecord, freespinsAwarded - lastRecord.getFreespinsWon());

            triggerRecord.cashWon =  parseInt(packet.Response.Slot.attributes.freeSpinTotalWin);

            records = [triggerRecord, ...dummyFreespins];

            return records;
        }

        return [this.createTriggerRecord(records[0], 0), ...records];
    }

    public createDummyFreespinRecords(originalRecord: SpinRecord, freespinsPlayed: number): FreespinRecord[] {
        const records: FreespinRecord[] = [];
        for (let i = 0; i < freespinsPlayed; i++) {
            const fsRecord = new FreespinRecord();
            fsRecord.hasChildren = false;
            fsRecord.lastChild = false;
            fsRecord.grid = originalRecord.grid;
            fsRecord.reelset = originalRecord.reelset;
            fsRecord.cashWon = 0;
            fsRecord.overlayGrid = originalRecord.overlayGrid;
            records.push(fsRecord);
        }
        return records;
    }

    public createTriggerRecord(originalRecord: SpinRecord, freespinsAwarded: number): SpinRecord {
        const result = new FreespinWinResult();
        result.freespinsWon = freespinsAwarded;

        const record: SpinRecord = new SpinRecord();
        record.hasChildren = true;
        record.lastChild = false;
        record.grid = originalRecord.grid;
        record.reelset = originalRecord.reelset;
        record.cashWon = originalRecord.cashWon;
        record.overlayGrid = originalRecord.overlayGrid;
        record.results.push(result);

        return record;
    }
}

export default new SGRecoverySpinRecordBuilder();
